import { TableHeader } from "@/components/table/generic-table.vue";
import {
    AreaEventHistoryColumnDef,
    AreaEventHistoryColumnKey,
    AreaEventHistoryColumnPref,
    areaEventHistoryDefaultColumns,
    conditionalAreaEventHistoryColumns
} from "@/types/sv-data/AreaEventHistory";

function columnDefToTableHeader(columnDefinition: AreaEventHistoryColumnDef): TableHeader {
    const header: TableHeader = {
        title: columnDefinition.label,
        key: columnDefinition.key,
        order: columnDefinition.order,
        sortOrder: 0,
        sortOrderReversed: false,
        visible: columnDefinition.defaultVisible,
        sortable: columnDefinition.sortable,
    };

    if (columnDefinition.useCustomCell) {
        header.useCustomCell = columnDefinition.useCustomCell;
    }

    if (columnDefinition.isTermLabel) {
        header.isTermLabel = columnDefinition.isTermLabel;
    }

    if (columnDefinition.style) {
        header.style = columnDefinition.style;
    }

    return header;
}

export function buildAvailableColumns(getFeature: (keys: string[]) => boolean): TableHeader[] {
    const columns = areaEventHistoryDefaultColumns.map(columnDefToTableHeader);
    if (getFeature(["Areas", "AreaEventHistory", "AdditionalColumns", "AlarmExtraValue"])) {
        columns.push(columnDefToTableHeader(conditionalAreaEventHistoryColumns[AreaEventHistoryColumnKey.AlarmExtraValue]!));
    }

    if (getFeature(["Areas", "AreaEventHistory", "AdditionalColumns", "EventTypeTitle"])) {
        columns.push(columnDefToTableHeader(conditionalAreaEventHistoryColumns[AreaEventHistoryColumnKey.EventTypeTitle]!));
    }

    return columns;
}

function isValidAreaEventHistoryColumn(obj: unknown): obj is AreaEventHistoryColumnPref {
    try {
        if (!obj || typeof obj !== "object") {
            return false;
        }
        const pref = obj as Record<string, unknown>;
        return (
            typeof pref.key === "string" &&
            Object.values(AreaEventHistoryColumnKey).includes(pref.key as AreaEventHistoryColumnKey) &&
            typeof pref.visible === "boolean"
        );
    } catch (error) {
        console.error("[AreaEventHistory] Failed to validate column preference", { error, obj });
        return false;
    }
}

export function parseEventAreaHistoryColumnPrefs(prefsString: string): AreaEventHistoryColumnPref[] {
    try {
        const parsed: unknown = JSON.parse(prefsString);
        if (!Array.isArray(parsed)) {
            return [];
        }
        const valid = parsed.filter(isValidAreaEventHistoryColumn);
        if (valid.length === 0) {
            return [];
        }
        return valid;
    } catch (error) {
        console.error("[AreaEventHistory] Failed to parse column preferences", { error, prefsString });
        return [];
    }
}